import { Navigation } from "./navigation";

import "./styles/global.scss";

function App() {
  return <Navigation />;
}

export default App;
